import { render } from "./PesageDynamique.vue?vue&type=template&id=8fc04d3e"
const script = {}

import "./PesageDynamique.vue?vue&type=style&index=0&id=8fc04d3e&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.10_vue@3.5.10_webpack@5.95.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__